"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrashCanIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.TrashCanIcon16Light = forwardRef_1.forwardRef('TrashCanIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M6 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Z" }),
        react_1.default.createElement("path", { d: "M7.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Z" }),
        react_1.default.createElement("path", { d: "M10 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Z" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 2.75V4H1a.5.5 0 0 0 0 1h1.048l.82 8.199A2 2 0 0 0 4.857 15h5.285a2 2 0 0 0 1.99-1.801L12.953 5H14a.5.5 0 0 0 0-1h-3V2.75A1.75 1.75 0 0 0 9.25 1h-3.5A1.75 1.75 0 0 0 4 2.75ZM5.75 2a.75.75 0 0 0-.75.75V4h5V2.75A.75.75 0 0 0 9.25 2h-3.5Zm6.197 3-.81 8.1a1 1 0 0 1-.995.9H4.857a1 1 0 0 1-.995-.9L3.052 5h8.895Z" })));
});
